import * as ngCore from '@angular/core'

@ngCore.Component({
  selector: 'atn-ds-pill-button',
  standalone: true,
  styleUrls: ['./pill-button.component.scss'],
  templateUrl: './pill-button.component.html',
})
export class AtnDsPillButtonComponent {
  public readonly isActiveSg = ngCore.input<boolean | undefined>(false, {
    alias: 'isActive',
  })
}
